var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageNotFound"},[_vm._v(" not ")])}
var staticRenderFns = []

export { render, staticRenderFns }